// React imports.
import React, { Component,   } from "react";

// App imports.
import Assessment1 from "./Assessment1";
import Assessment2 from "./Assessment2";
import Assessment3 from "./Assessment3";
import Assessment4 from "./Assessment4";
import Assessment5 from "./Assessment5";
import StartPage from "./StartPage";
import SelectStateAndYear from "./SelectStateAndYear";
import StartNewAssessment from "./StartNewAssessment";

import {AppPagesEnum} from "../state";

import { createState } from "../state";
//import spinnerImage from "../../images/spinner-small.gif";


class BaseLayout extends Component {
    state = createState(this);

    /**
     * Render().
     */
    render() {
        return (
          <div className="appContainer">
                <h1>LIHEAP Data Reliability Assessment Tool - Main Heating Expenditures</h1>
                {/*----------------------------
                 * Display error message
                 * ----------------------------*/}
                {this.state.ShowSpinner == true
                  && <img src="/data_warehouse/images/spinner-small.gif" alt="Image to show that page is loading" className="spinner" style={{ padding: 20, }} />
                }
                {(this.state.ErrorMessage !== '')
                  && <span className="errorMessageText"><br/><br/>{this.state.ErrorMessage}<br/><br/></span>
                }
                {/*----------------------------*/}  

                <div  className="innerPageDivs">
                    <div className="pseudo-accordion " >
                        <h2>{this.state.MainHeader}</h2>

                        { (this.state.SelectedYear != null
                          && this.state.SelectedGranteeId != null
                          && this.state.CurrentAppPage !==  AppPagesEnum.StartPage
                          && this.state.CurrentAppPage !==  AppPagesEnum.StartNewAssessment
                          && this.state.CurrentAppPage !==  AppPagesEnum.SelectStateAndYear)
                        &&<h3>{this.state.SelectedGranteeName},  {this.state.SelectedYear}</h3>
                        }

                        {this.state.CurrentAppPage ===  AppPagesEnum.StartPage
                            && <StartPage state={this.state} />}
                        {this.state.CurrentAppPage ===  AppPagesEnum.StartNewAssessment
                            && <StartNewAssessment state={this.state} />}
                        {this.state.CurrentAppPage ===  AppPagesEnum.SelectStateAndYear
                            && <SelectStateAndYear state={this.state} />}
                        {this.state.CurrentAppPage ===  AppPagesEnum.Assessment1
                            && <Assessment1 state={this.state} />}
                        {this.state.CurrentAppPage ===  AppPagesEnum.Assessment2
                            && <Assessment2 state={this.state} />}
                        {this.state.CurrentAppPage ===  AppPagesEnum.Assessment3
                            && <Assessment3 state={this.state} />}
                        {this.state.CurrentAppPage ===  AppPagesEnum.Assessment4
                            && <Assessment4 state={this.state} />}
                        {this.state.CurrentAppPage ===  AppPagesEnum.Assessment5
                            && <Assessment5 state={this.state} />}
                    </div>
                </div>
            


              

              
          </div>
        );
    }

}
export default BaseLayout;
